// runtime.js
// Small shared helpers used across pages.

// Hydrate sections when they are near the viewport.
// Opt in by adding: data-hydrate data-module="section-name"
const bootSection = async (el) => {
  const name = el.dataset.module;
  if (!name) return;
  try {
    const mod = await import(`./${name}.js`);
    if (mod && typeof mod.init === 'function') {
      mod.init(el);
    }
  } catch (e) {
    console.error('[runtime] Failed to load module', name, e);
  }
};

const observeSections = () => {
  const list = document.querySelectorAll('[data-hydrate]');
  if (!list.length) return;

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        bootSection(entry.target);
        io.unobserve(entry.target);
      }
    }, { rootMargin: '200px' });

    list.forEach((el) => io.observe(el));
  } else {
    // Fallback
    list.forEach((el) => setTimeout(() => bootSection(el), 0));
  }
};

// Idle helper for low priority work.
export const idle = (cb) => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(cb, { timeout: 2500 });
  } else {
    setTimeout(cb, 1500);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  observeSections();
});

